const KEYS_TO_KEEP = [
  'txReceipt',
  'balanceDifferences',
  'decodedCallStack',
  'addressVisibility',
  'callStackVisibility',
  'logsVisibility',
];

/**
 * Process Transaction Decode Report JSON data
 * @param {Array} txnData - Array of JSON file objects
 * @param {string} input - User input text
 * @param {Array} uploadedImages - Uploaded images
 * @returns {Object} - Object containing processed JSON files and messages
 */
export const processFullTxnDecode = (txnData, input, uploadedImages) => {
  const txn = JSON.parse(JSON.stringify(txnData[0].data));

  // Remove unnecessary keys
  for (const key in txn) {
    if (!KEYS_TO_KEEP.includes(key)) {
      delete txn[key];
    }
  }

  // trim raw data
  if (txn.txReceipt.input) {
    delete txn.txReceipt.input;
  }

  if (txn.txReceipt.output) {
    delete txn.txReceipt.output;
  }

  if (txn.txReceipt.logs) {
    txn.txReceipt.logs = txn.txReceipt.logs
      .filter((log) => 'decodedLog' in log)
      .forEach((log) => {
        delete log.rawLog;
      });
  }

  if (txn.decodedCallStack) {
    const q = [txn.decodedCallStack];

    while (q.length) {
      const call = q.shift();

      if (call.rawCall) {
        delete call.rawCall;
      }

      if (call.children) {
        q.push(...call.children);
      }
    }
  }

  // Create first system message with original JSON data
  const systemDataMessage = {
    role: 'user',
    content: `
      Instructions:
      
      Analyze this Blockscope Transaction Decode Report and provide a response to the user.
  
      Detailed transaction data:
      ${JSON.stringify(txn, null, 2)}
      `,
  };

  // Create user message
  const userMessage = {
    role: 'user',
    content: [
      {
        type: 'text',
        text: input, // inputmessage is fetched from actionplan default
      },
      ...(uploadedImages
        ? uploadedImages.map((m) => ({ type: 'image', image: m[0] }))
        : []),
    ],
  };

  return {
    messages: {
      dataMessages: [systemDataMessage],
      userMessage,
    },
  };
};

